module.exports = __webpack_public_path__ + "assets/img/9bc2bf87cb983cd742d3ef21e46663b2.png";